import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_base_label = _resolveComponent("bs5-base-label")!
  const _component_bs5_base_input = _resolveComponent("bs5-base-input")!
  const _component_bs5_cancel_button = _resolveComponent("bs5-cancel-button")!
  const _component_bs5_save_button = _resolveComponent("bs5-save-button")!
  const _component_bs5_base_modal = _resolveComponent("bs5-base-modal")!

  return (_openBlock(), _createBlock(_component_bs5_base_modal, {
    title: "Add New User",
    visible: _ctx.visible,
    onClose: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addUser && _ctx.addUser(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_bs5_base_label, { for: "fullName" }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Full Name")
            ])),
            _: 1
          }),
          _createVNode(_component_bs5_base_input, {
            modelValue: _ctx.newUser.fullName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newUser.fullName) = $event)),
            type: "text",
            id: "fullName",
            required: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_bs5_base_label, {
            for: "email",
            class: "form-label"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Email")
            ])),
            _: 1
          }),
          _createVNode(_component_bs5_base_input, {
            modelValue: _ctx.newUser.email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newUser.email) = $event)),
            type: "email",
            id: "email",
            required: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_bs5_base_label, {
            for: "role",
            class: "form-label"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("Role")
            ])),
            _: 1
          }),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newUser.role) = $event)),
            class: "form-select",
            id: "role"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userRoles, (label, value) => {
              return (_openBlock(), _createElementBlock("option", {
                key: value,
                value: value
              }, _toDisplayString(label), 9, _hoisted_4))
            }), 128))
          ], 512), [
            [
              _vModelSelect,
              _ctx.newUser.role,
              void 0,
              { number: true }
            ]
          ])
        ])
      ], 32)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_bs5_cancel_button, { onClick: _ctx.closeModal }, null, 8, ["onClick"]),
      _createVNode(_component_bs5_save_button, {
        onClick: _ctx.addUser,
        loading: _ctx.saving
      }, null, 8, ["onClick", "loading"])
    ]),
    _: 1
  }, 8, ["visible", "onClose"]))
}